<template>
  <section class="content">
    <!-- <keep-alive> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">Sales Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Store</label>
              <Dropdown v-if="!setWarehouseData" v-model="warehouseId" :options="warehouseLists" optionLabel="name"
                id="warehouse" :filter="true" placeholder="Select store" :showClear="true" />
              <Dropdown v-if="setWarehouseData" v-model="warehouseId" :options="warehouseLists" optionLabel="name"
                id="warehouse" :filter="true" placeholder="Select store" :disabled="true" />
            </div>


            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button @click.prevent="searchUnsettledSales" class="p-button-raised" label="Search" icon="pi pi-search" />
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button v-if="this.unSettleSalesChildHeaderLists.length > 0" @click.prevent="reset"
                class="p-button-raised p-button-warning" icon="pi pi-refresh" label="Reset" />
            </div>
          </div>
        </form>
        <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
          v-if="this.unSettleSalesChildHeaderLists.length > 0">
          <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;" />
        </a>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">


            <label for="name">Cash Sales: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.cashSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Esewa Sales: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.esewaSales }}</label>
          </div>



          <div class="p-field p-col-12 p-md-2">


            <label for="name">Fonepay Sales: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.fonepaySales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Khalti Sales : <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.khaltiSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Ncm Sales : <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.darazSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Bank Sales : <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.bankSales }}</label>
          </div>

        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label for="name">Unpaid Cash: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.cashUnpaidSales }}</label>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="name">Unpaid Esewa: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.esewaUnpaidSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">


            <label for="name"> Unpaid Fonepay: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.fonepayUnpaidSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Unpaid Khalti: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.khaltiUnpaidSales }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Unpaid Ncm: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.totalDarazUnpaid }}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="name">Unpaid Bank: <span style="color:red"></span></label>
            <label type="text" style="color:blue" ref="name">{{ this.bankUnpaidSales }}</label>
          </div>
        </div>

        <label style="color:red" for="name">Note: Please Settel By Particular Store User Assigned.<span
            style="color:red"></span></label>
        <!-- <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12"> -->
    </div>
            <div class="box box-info">
        <DataTable :value="unSettleSalesChildHeaderLists" :paginator="true" ref="po" editMode="cell" :rows="100"
          :filters="filters" :rowsPerPageOptions="[100, 500, 1000]" class="p-datatable-responsive p-datatable-gridlines"
           data-key="id">

          <Column header="Miti" :sortable="true" field="salesDateNepali" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['salesDateNepali']" />
            </template>
          </Column>
          <Column header="Date" :sortable="true" field="salesDate" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['salesDate']" />
            </template>
          </Column>
          <Column header="Time" :sortable="true" field="time" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['time']" />
            </template>
          </Column>
          <Column header="Bill No" :sortable="true" field="billPrefix" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['billPrefix']" />
            </template>
          </Column>
          <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['customerName']" />
            </template>
            <template #footer>
              Total:
            </template>
          </Column>
          <Column header="Contact" :sortable="true" field="contactNumber" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>
          <Column header="Address" :sortable="true" field="deliveryAddress" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['deliveryAddress']" />
            </template>
          </Column>
          <Column header="Pay status" bodyStyle="text-align: right" field="paymentStatus" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']" />
            </template>
            <template #editor="slotProps">
              <Dropdown v-model="slotProps.data['paymentStatus']" :options="statusesPay"
                @change="updatePaymentStatus(slotProps.data)" optionLabel="label" optionValue="value"
                placeholder="Select a Status">
                <template #option="slotProps">
                  <span>{{ slotProps.option.label }}</span>
                </template>
              </Dropdown>
            </template>
            <template #body="slotProps">
              {{ getPayStatusLabel(slotProps.data.paymentStatus) }}
            </template>
          </Column>
          <Column header="Pay Method" bodyStyle="text-align: right" field="paymentMethod" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['paymentMethod']" />
            </template>
            <template #editor="slotProps">
              <Dropdown v-model="slotProps.data['paymentMethod']" :options="payMethod"
                @change="updatePaymentStatus(slotProps.data)" optionLabel="label" optionValue="value"
                placeholder="Select a Status">
                <template #option="slotProps">
                  <span>{{ slotProps.option.label }}</span>
                </template>
              </Dropdown>
            </template>
            <template #body="slotProps">
              {{ getPaymentMethodLabel(slotProps.data.paymentMethod) }}
            </template>
          </Column>
          <Column header="Dis Amt" bodyStyle="text-align: right" field="discountAmount" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['discountAmount']" />
            </template>
            <template #footer>
              {{ totalDiscountAmount.toFixed(2) }}
            </template>
          </Column>
          <Column header="Amount" bodyStyle="text-align: right" field="billAmount" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['billAmount']" />
            </template>
            <template #footer>
              {{ totalBillAmount.toFixed(2) }}
            </template>
          </Column>
          <Column header="Counter" bodyStyle="text-align: right" field="counterName" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['counterName']" />
            </template>
          </Column>
          <Column header="Store" bodyStyle="text-align: right" field="warehouseName" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['warehouseName']" />
            </template>
          </Column>
          <Column header="Entered By" bodyStyle="text-align: right" field="enteredBy" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['enteredBy']" />
            </template>
          </Column>

          <Column header="Updated By" bodyStyle="text-align: right" field="updatedBy" :sortable="true"
            filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']" />
            </template>
          </Column>
          <Column header="Action" headerStyle="width:14em">
            <template #body="slotProps">
              <Button v-if="enableDelete" class="p-button-raised p-button-danger" v-tooltip.top="'Delete'"
                @click="openDialog(slotProps.data.id)" icon="pi pi-trash" />
              <Button v-else disabled class="p-button-raised p-button-danger" v-tooltip.top="'Delete'"
                @click="openDialog(slotProps.data.id)" icon="pi pi-trash" />
              <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                @click.prevent="viewUnsettleDetail(slotProps.data)" />
              <Button icon="pi pi-print" class="p-button-raised" v-tooltip.top="'Print'"
                @click="printPage(slotProps.data)" />
              <Button icon="pi pi-ticket" class="p-button-raised" v-tooltip.top="'Print KOT'"
                @click="printKOTPage(slotProps.data)" />
              <Button icon="fa fa-truck" v-if="slotProps.data.deliveryAddress !== ''" v-tooltip.top="'Delivery'"
                class="p-button-raised" @click="printDeliveryPage(slotProps.data)" />
              <Button icon="pi pi-refresh" v-if="slotProps.data.deliveryAddress !== ''" v-tooltip.top="'Exchange'"
                class="p-button-raised p-button-secondary" @click="printExchangePage(slotProps.data)" />
              <Button icon="pi pi-pencil" v-tooltip.top="'Edit'" class="p-button-raised p-button-secondary"
                @click="editPosSales(slotProps.data)" />
            </template>
          </Column>
          <template #empty>No record found</template>
        </DataTable>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-10"></div>
          <div class="p-field p-col-12 p-md-2 p-mt-2">
            <Button style="float:right" v-if="this.enableSettle" class="p-button-raised p-button-success" label="Settle"
              @click.prevent="settleSales()" />
            <Button v-else disabled style="float:right" class="p-button-raised p-button-success" label="Settle"
              @click.prevent="settleSales()" />
          </div>
        </div>
      </div>
    </div>
    <!-- </div>
    </div> -->
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport" />
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Dialog from '../../layout/dialog'

export default {
  name: 'UnSettleReport',
  data() {
    return {
      fromDate: null,
      // toDate: null,
      enableSettle: false,
      loading: false,
      filters: {},
      dialogShow: false,
      setWarehouseData: false,
      columnList: '',
      englishDateEnabled: true,
      cashSales: 0,
      esewaSales: 0,
      khaltiSales: 0,
      darazSales: 0,
      bankSales: 0,
      fonepaySales: 0,
      khaltiUnpaidSales: 0,
      darazUnpaidSales: 0,
      bankUnpaidSales: 0,
      fonepayUnpaidSales: 0,
      cashUnpaidSales: 0,
      esewaUnpaidSales: 0,
      statusesPay: [{ label: 'Paid', value: 'Paid' }, { label: 'Unpaid', value: 'Unpaid' }],
      payMethod: [{ label: 'Cash', value: 'CASH' }, { label: 'Esewa', value: 'ESEWA' }, {
        label: 'Fonepay',
        value: 'FONEPAY'
      }, { label: 'Khalti', value: 'Khalti' }, { label: 'Bank', value: 'Bank' }, { label: 'Ncm', value: 'Ncm' }],
      warehouseId: '',
      totalDiscountAmount: 0,
      totalBillAmount: 0
    }
  },
  computed: {
    unSettleSalesChildHeaderLists() {
      return this.$store.state.pos.unSettleSalesChildHeaderLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.checkEnableDelete()
    this.checkEnableSettle()
    this.warehouseList()
    this.setWarehouse()
    this.columnNames()
    this.totalBalance()
  },
  methods: {
    async searchUnsettledSales() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let date = {
        fromDate: this.fromDate,
        warehouse: this.id
        // toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadUnSettleSalesChildHeaderLists', date)
      this.loading = false
      if (resp.data.data.length > 0) {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        this.returnTotalSales()
        this.totalBalance()
      } else if (resp.data.data.length === 0) {
        this.$toast.add({ severity: 'warn', summary: '', detail: 'No data available!', life: 3000 })
        this.cashSales = 0.0
        this.esewaSales = 0.0
        this.khaltiSales = 0.0
        this.darazSales = 0.0
        this.bankSales = 0.0
        this.fonepaySales = 0.0
        this.khaltiUnpaidSales = 0.0
        this.darazUnpaidSales = 0.0
        this.bankUnpaidSales = 0.0
        this.fonepayUnpaidSales = 0.0
      }
    },
    async updatePaymentStatus(data) {
      let payment = {
        id: data.id,
        status: data.paymentStatus,
        method: data.paymentMethod
      }
      let response = await this.$store.dispatch('paymentStatusUpdate', payment)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: 'Payment Status' + response.data.message,
          life: 3000
        })
      }
      // // debugger
    },
    totalBalance() {
      this.totalBillAmount = 0.0
      this.totalDiscountAmount = 0.0
      for (let sale of this.unSettleSalesChildHeaderLists) {
        this.totalBillAmount += sale.billAmount
        this.totalDiscountAmount += sale.discountAmount
      }
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async settleSales() {
      let resp = ''
      let dat = {
        fromDate: this.fromDate
        // toDate: this.toDate
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('settleSales', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        this.unSettleSalesChildHeaderLists = []
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({ severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000 })
        this.dialogShow = true
        return
      }
      let deleteRe = {
        id: this.posSalesId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePosSales', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 10000 })
      } else {
        this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 10000 })
      }
      this.dialogShow = false
    },
    returnTotalSales() {
      this.cashSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalCashSales
      this.esewaSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalEsewaSales
      this.cashUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalCashUnPaidSales
      this.esewaUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalEsewaUnPaidSales
      this.khaltiSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalKhaltiSales
      this.darazSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalDarazSales
      this.bankSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalBankSales
      this.fonepaySales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalFonepaySales
      this.khaltiUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalKhaltiUnpaid
      this.darazUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalDarazUnpaid
      this.bankUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalBankUnpaid
      this.fonepayUnpaidSales = this.unSettleSalesChildHeaderLists[this.unSettleSalesChildHeaderLists.length - 1].totalFonepayUnpaid
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    printPage(data) {
      data.printTyp = 'bill'
      this.$router.push({ name: 'posPrintPage', params: { printData: data } })
    },
    printKOTPage(data) {
      data.printTyp = 'qott'
      this.$router.push({ name: 'posPrintPage', params: { printData: data } })
    },
    printDeliveryPage(data) {
      this.$router.push({ name: 'posDeliveryPrint', params: { printData: data } })
    },
    printExchangePage(data1) {
      data1.billAmount = 0
      this.$router.push({ name: 'posDeliveryPrint', params: { printData: data1 } })
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.posSalesId = id
    },
    async viewUnsettleDetail(data) {
      // debugger
      let UnsettledSales = {
        returningAmount: data.returningAmount,
        contactNumber: data.contactNumber,
        billPrefix: data.billPrefix,
        billNo: data.billNo,
        paymentMethod: data.paymentMethod,
        salesDateNepali: data.salesDateNepali,
        subTotalAmount: data.subTotal,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        billAmount: data.billAmount,
        vatTypeEnum: data.vatTypeEnum,
        tenderAmount: data.tenderAmount,
        discountAmt: data.discountAmount,
        remarks: data.remarks,
        deliveryAddress: data.deliveryAddress,
        deliveryAmount: data.deliveryAmount,
        childSalesDetailsDTOList: data.childSalesDetailsDTOList
      }
      this.$router.push({ name: 'Unsettled Details', params: { UnsettledData: UnsettledSales } })
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        // toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelPosReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.fromDate + '/unSettled' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unsettlePosSales.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    getPayStatusLabel(payStatus) {
      switch (payStatus) {
        case 'Paid':
          return 'Paid'

        case 'Unpaid':
          return 'Unpaid'

        default:
          return 'NA'
      }
    },
    getPaymentMethodLabel(payMethod) {
      switch (payMethod) {
        case 'ESEWA':
          return 'Esewa'
        case 'CASH':
          return 'Cash'
        case 'FONEPAY':
          return 'Fonepay'
        case 'Khalti':
          return 'Khalti'
        case 'Bank':
          return 'Bank'
        case 'Ncm':
          return 'Ncm'
        default:
          return 'NA'
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      // this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    reset() {
      // if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      //   this.setNepaliDate()
      // } else {
      //   this.setEnglishDate()
      // }
      window.location.reload()
    },
    editPosSales(data) {
      this.$router.push({ name: 'Point of Sales', params: { pos: data } })
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        // this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    checkEnableSettle() {
      if (this.$store.getters.modules.includes(',7.11')) {
        this.enableSettle = true
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      // $('#toDate').nepaliDatePicker({
      //   ndpYear: true,
      //   ndpMonth: true,
      //   ndpYearCount: 10,
      //   disableBefore: this.$store.state.startDate,
      //   disableAfter: this.$store.state.endDate,
      //   onChange: () => {
      //     this.toDate = $('#toDate').val()
      //   }
      // })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dropdown,
    InputText,
    Button,
    InputMask,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// posUnSettleSales.vue?0e3b96ae